import React from "react";
import { ISVG } from "./interface";

const SVG: React.FC<ISVG> = ({
  width = "16",
  height = "16",
  fill = "currentColor",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill={fill}
    {...props}
  >
    <path
      d="M12.7863 4.75481L9.98292 1.88381C9.64099 1.54203 9.16239 1.33695 8.61539 1.33695H4.58119C3.55554 1.26859 2.66666 2.15724 2.66666 3.18259V12.7526C2.66666 13.7779 3.48717 14.6666 4.58119 14.6666H11.4188C12.4445 14.6666 13.3333 13.8463 13.3333 12.7526V6.05359C13.3333 5.57509 13.1282 5.09659 12.7863 4.75481ZM5.94871 6.73718H7.99999C8.27352 6.73718 8.54699 6.94225 8.54699 7.28405C8.54699 7.62578 8.34186 7.83085 7.99999 7.83085H5.94871C5.6752 7.83085 5.4017 7.62578 5.4017 7.28405C5.4017 6.94225 5.6752 6.73718 5.94871 6.73718ZM10.0513 10.5652H5.94871C5.6752 10.5652 5.4017 10.3601 5.4017 10.0183C5.4017 9.67651 5.60683 9.47145 5.94871 9.47145H10.0513C10.3248 9.47145 10.5983 9.67651 10.5983 10.0183C10.5983 10.3601 10.3248 10.5652 10.0513 10.5652Z"
      fill="var(--tlx-cta-primary-default)"
    />
  </svg>
);

export default SVG;
